import { NestedTreeControl } from '@angular/cdk/tree';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';

export interface TreeNode {
  name: string;
  children?: TreeNode[];
}

@Component({
  selector: 'labs-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeComponent implements OnChanges {
  @Input() data: TreeNode[];

  @Input() closedIcon = 'folder';

  @Input() openedIcon = 'folder_open';

  @Input() nodeIcon = 'insert_drive_file';

  dataSource = new MatTreeNestedDataSource<TreeNode>();

  treeControl = new NestedTreeControl<TreeNode>((node) => node.children);

  hasChild = (_: number, node: TreeNode) =>
    !!node.children && node.children.length > 0;

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = changes.data ? changes.data.currentValue : null;
  }
}
